import { useState } from "react";
import { useDispatch } from "react-redux";

import { useGetNonEnrolledPatientsQuery } from "app/store/patient/api/patientApi";
import {
  changePatient,
  toggleModal,
} from "app/store/transmission/slice/transmissionSlice";
import { textFilter } from "utils/table";
import { Button } from "@mui/material";
import { formatDateTime } from "utils/date";
import { toggleEnrollModal } from "app/store/nonCompliantPatient/slice/nonCompliantPatientSlice";

const useNonEnrolledPatientsTable = () => {
  const [sorting, setSorting] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const dispatch = useDispatch();

  const { data, isLoading, isFetching, isError } =
    useGetNonEnrolledPatientsQuery(
      {
        page: pagination?.pageIndex + 1,
        pageSize: pagination?.pageSize,
        filters: columnFilters,
        sorting,
      },
      { refetchOnMountOrArgChange: true }
    );

  const handleRowClick = (rowData) => {
    dispatch(
      changePatient({
        patientId: rowData?._id,
        serialNumber: rowData?.serial_number,
        account: rowData?.account,
      })
    );
    dispatch(toggleModal({ type: "patient", value: true }));
  };

  const columns = [
    {
      header: "Name",
      accessorKey: "name",
      filterFn: textFilter,
    },
    {
      header: "Model Name",
      accessorKey: "modelName",
      filterFn: textFilter,
    },
    {
      header: "DOI",
      accessorKey: "doi",
      filterFn: textFilter,
      filterVariant: "date",
      Cell: ({ row }) => formatDateTime(row?.original?.doi),
    },
    {
      header: "Serial Number",
      accessorKey: "serialNumber",
      filterFn: textFilter,
    },
    {
      header: "Account",
      accessorKey: "account",
      filterFn: textFilter,
    },
    {
      header: "Manufacturer",
      accessorKey: "manufacturer",
      filterFn: textFilter,
    },
    {
      header: "Last Send Date",
      accessorKey: "lastSend",
      filterFn: textFilter,
      filterVariant: "date",
      Cell: ({ row }) => {
        const rowData = row?.original;
        return rowData?.lastSend ? formatDateTime(rowData?.lastSend) : "—";
      },
    },
    {
      header: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableColumnFilter: false,
      accessorFn: (rowData) => (
        <Button
          sx={{
            "&:hover": {
              background: "#94BA33",
              color: "#fff",
            },
          }}
          variant="outlined"
          color="secondary"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();

            dispatch(
              toggleEnrollModal({
                showModal: true,
                patient: rowData,
              })
            );
          }}
        >
          Enroll Patient
        </Button>
      ),
    },
  ];

  return {
    columns,
    data,
    isLoading,
    isFetching,
    isError,
    pagination,
    setPagination,
    handleRowClick,
    columnFilters,
    setColumnFilters,

    sorting,
    setSorting,
  };
};

export default useNonEnrolledPatientsTable;
